<template>
  <section v-if="items" class="def-bread-crumbs">
    <div v-for="(item, i) in items" :key="i" class="def-bread-crumbs__item">
      <a :href="item.LINK" class="def-bread-crumbs__link">
        <svg v-if="screenWidth < 768" class="def-bread-crumbs__arrow">
          <use xlink:href="#svg-arrow-left"></use>
        </svg>
        <span v-html="item.TITLE"></span>
      </a>

      <span v-if="i !== items.length - 1" class="def-bread-crumbs__slash">/</span>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import useScreenWidth from '@use/useScreenWidth';

export default {
  name: 'DefBreadCrumbs',
  props: ['result'],
  data() {
    return {
      screenWidth: useScreenWidth(),
    };
  },
  computed: {
    ...mapState({
      breadcrumbs: ({ results }) => results.breadcrumbs,
    }),
    items() {
      if (this.screenWidth < 768) {
        if (this.result) {
          return this.result.slice(this.result.length - 2, this.result.length - 1);
        }
        return this.breadcrumbs.slice(this.breadcrumbs.length - 2, this.breadcrumbs.length - 1);
      }
      if (this.result) {
        return this.result;
      }
      return this.breadcrumbs;
    },
  },
};
</script>

<style lang="scss" scoped>
.def-bread-crumbs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 12px 0;
  font-size: rem(12);
  line-height: 100%;
  color: #363636;
  @include point-md {
    padding: 16px 0;
  }
  &__slash {
    margin: 0 5px;
  }
  &__item {
    display: flex;
    align-items: center;
  }
  &__link {
    display: flex;
    align-items: center;
  }
  &__arrow {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 4px;
    fill: #5f5f67;
  }
}
</style>
